import script from "./CommerceShippingRules.vue?vue&type=script&setup=true&lang=js"
export * from "./CommerceShippingRules.vue?vue&type=script&setup=true&lang=js"

import "./CommerceShippingRules.vue?vue&type=style&index=0&id=189d2727&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src4197/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-189d2727"]])

export default __exports__